import { mutateState } from '../c-mp/fun/useState'
import { appState } from '../model/appState'
import type { IState } from '../model/IState'
import { Page } from '../model/Page'

if (!(globalThis as any).URLPattern) {
	await import('urlpattern-polyfill')
}

export const urlPatterns = [
	{
		name: Page.Search,
		pattern: new URLPattern({ pathname: '/search' }),
	},
	{
		name: Page.PersonContemporaries,
		pattern: new URLPattern({ pathname: '/person/:personId/contemporaries' }),
	},
	{
		name: Page.PersonTree,
		pattern: new URLPattern({ pathname: '/person/:personId/tree' }),
	},
	{
		name: Page.Person,
		pattern: new URLPattern({ pathname: '/person/:personId' }),
	},
	{
		name: Page.RelativesAlive,
		pattern: new URLPattern({ pathname: '/relatives-alive' }),
	},
	{
		name: Page.Parentless,
		pattern: new URLPattern({ pathname: '/parentless' }),
	},
	{
		name: Page.Birthdays,
		pattern: new URLPattern({ pathname: '/birthdays' }),
	},
	{
		name: Page.WeddingAnniversaries,
		pattern: new URLPattern({ pathname: '/wedding-anniversaries' }),
	},
	{
		name: Page.Emails,
		pattern: new URLPattern({ pathname: '/emails' }),
	},
	{
		name: Page.AverageAge,
		pattern: new URLPattern({ pathname: '/average-age' }),
	},
	{
		name: Page.Clouds,
		pattern: new URLPattern({ pathname: '/clouds' }),
	},
	{
		name: Page.Quiz,
		pattern: new URLPattern({ pathname: '/quiz' }),
	},
	{ name: Page.Home, pattern: new URLPattern({ pathname: '/' }) },
	{ name: Page.Home, pattern: new URLPattern({ pathname: '' }) },
]

export function useRouting() {
	window.addEventListener('click', onLinkClick)
	window.addEventListener('popstate', onPopState)
	onPopState()
}

function onLinkClick(e: MouseEvent) {
	if (e.defaultPrevented) return
	if (e.target instanceof Element) {
		const a = e.target.closest('a')
		let url: URL | undefined
		if (a instanceof HTMLAnchorElement) url = new URL(a.href)
		if (a instanceof SVGAElement) url = new URL(a.href.baseVal)
		if (url && url.host === location.host) {
			e.preventDefault()
			history.pushState(undefined, '', url)
			window.scrollTo(0, 0)
			onPopState()
		}
	}
}

export function onPopState() {
	clearTimeout(updateHistoryStateRef)
	let match = null
	let page = Page.NotFound
	for (const urlPattern of urlPatterns) {
		match = urlPattern.pattern.exec(location.href)
		if (match) {
			page = urlPattern.name
			break
		}
	}
	console.log(`Page:`, page)
	mutateState('useRouting', 'onPopState', () => {
		appState.pathMatch = match
		appState.page = page
	})
}

export function pushState(url: string) {
	if (new URL(url, location.origin).host === location.host) {
		history.pushState(undefined, '', url)
		window.scrollTo(0, 0)
		onPopState()
	}
}

export function getHistoryState(): IState {
	return history.state ?? {}
}

let updateHistoryStateRef: ReturnType<typeof setTimeout> | undefined
export function updateHistoryState(updater: (state: IState) => IState) {
	clearTimeout(updateHistoryStateRef)
	updateHistoryStateRef = setTimeout(() => {
		history.replaceState(updater(getHistoryState()), '')
	}, 100)
}
